import store from "../../../store";
import uklon_market_export from './uklon_market_export.vue';

window.uklon_market_export =  new Vue({
    store,
    el: 'div#uklon-market_export',

    name : "uklon_market_export",
    data () {
        return {

        }
    },
    created () {

    },
    components : {
        uklon_market_export,
    }
});
